import {
  Box,
  Button,
  SuccessStateInfo,
  Typography,
  IconName,
  CustomDialog,
  APIActions,
} from 'web-library';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import { } from 'web-library/stories/atom/Icon/Icon';
import React from 'react';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { MutationStatus } from 'react-query';
import {typeTheme} from "web-library/theme/helper/tssHelper"

const useStyles = makeStyles()((theme) =>
({
  labelContainer: {
    '& img': {
      width: 45,
      height: 45,
    },
  },
  label: {
     ...typeTheme(theme, 'body1bold'),
  },
}));

const FileProcessedSuccessLabel = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <Box className={classes.labelContainer}>
      <SuccessStateInfo>
        <Typography variant="body1" className={classes.label}>
          {t('components->>FileProcessingSuccess.ProcessSuccess')}
        </Typography>
      </SuccessStateInfo>
    </Box>
  );
};

interface ReUploadButtonProps {
  onActionButtonClicked: () => void;
  onCancelButtonClicked: () => void;
  actionButtonApiStatus: MutationStatus;
  isReUploadModalOpen: boolean;
  setIsReUploadModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  amendment: boolean;
}

const ReUploadButton = ({
  onActionButtonClicked,
  onCancelButtonClicked,
  actionButtonApiStatus,
  isReUploadModalOpen,
  setIsReUploadModalOpen,
  amendment,
}: ReUploadButtonProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      <CustomDialog
        open={isReUploadModalOpen}
        title={t('components->>FileProcessingSuccess.ReUploadTitle')}
        message={t('components->>FileProcessingSuccess.ReUploadContent')}
        action={
          <APIActions
            onClose={() => {
              onCancelButtonClicked();
              setIsReUploadModalOpen(false);
            }}
            apiCall={onActionButtonClicked}
            apiStatus={actionButtonApiStatus}
            cancelString={t('components->>FileProcessingSuccess.Cancel')}
            apiString={t('components->>FileProcessingSuccess.Proceed')}
          />
        }
      />

      <Button
        id="button-re-upload"
        variant="text"
        onClick={() => {
          setIsReUploadModalOpen(true);
        }}
        color="primary"
        disabled={amendment}
      >
        <IconWithLabel
          iconName={IconName.export}
          iconSize="M"
          label={t('components->>FileProcessingSuccess.ReUploadFileLabel')}
          typographyProps={{
            variant: 'h5',
            color: 'inherit',
          }}
        />
      </Button>
    </Box>
  );
};

export { FileProcessedSuccessLabel, ReUploadButton };
